import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const CheckedListItem: React.FC<Props> = ({ fill = '#008EC6', ...props }) => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.83329 15.5C3.87525 15.5 0.666626 12.2914 0.666626 8.33333C0.666626 4.37529 3.87525 1.16666 7.83329 1.16666C11.7914 1.16666 15 4.37529 15 8.33333C15 12.2914 11.7914 15.5 7.83329 15.5ZM11.0121 6.76012C11.2478 6.47726 11.2096 6.05689 10.9268 5.82118C10.6439 5.58547 10.2235 5.62368 9.98783 5.90654L7.12183 9.34573L5.63803 7.86193C5.37768 7.6016 4.95557 7.6016 4.69522 7.86193C4.43487 8.12226 4.43487 8.5444 4.69522 8.80473L6.69523 10.8047C6.82769 10.9372 7.00969 11.0078 7.19683 10.9993C7.38396 10.9908 7.55889 10.904 7.67876 10.7601L11.0121 6.76012Z"
                fill={fill}
            />
        </svg>

    );
};

export default CheckedListItem;
